import api from "services/api";

export async function fetchCustomerMe(): Promise<Record<string, unknown>> {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const response = await api.get(`industrial/customer/v1/customers/me`, {
    headers,
  });
  return response.data;
}

export async function fetchUserByLogin(): Promise<Record<string, unknown>> {
  const login = localStorage.getItem("@UltragazEmpresarial:document");
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const params = {
    login,
    "is-active": true,
    _limit: 1,
    _offset: 0,
  };
  const response = await api.get("industrial/customer/v1/users", {
    params,
    headers,
  });
  return response.data[0];
}
